import React, {createRef, useContext, useEffect} from 'react';
import {Grid} from '@mantine/core';
import {useFormikContext} from 'formik'
import MantineInputField from "../../../../FormikUtils/MantineInputField";
import PhoneInput from "react-phone-number-input";
import MantineInputRefField from "../../../../FormikUtils/MantineInputRefField";
import MantineAutoCompleteField from "../../../../FormikUtils/MantineAutoCompleteField";
import useStyles from "../../../VehiculoForm/Checkout/styles";
import AffinityContext from "../../../../../../context/AffinityContext";

export default function InformacionForm(props) {
    const {
        formField: {
            codigosLocalidad,
            nombre,
            apellido,
            telefono,
            email,
            dni
        },
        localidadesData
    } = props;
    const {values, setFieldValue} = useFormikContext()
    const classes = useStyles();
    const ref = createRef();
    const {coberturasInfo} = useContext(AffinityContext);


    useEffect(() => {
        Object.keys(values.coberturas).map(cobertura => {
            setFieldValue(`coberturas.[${cobertura}].sumaAsegurada`, coberturasInfo[cobertura].sumaChica)
        })
    }, []);

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={nombre.name}
                        label={nombre.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={apellido.name}
                        label={apellido.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <div className={classes.field}>
                        <PhoneInput
                            defaultCountry="AR"
                            ref={ref}
                            inputComponent={MantineInputRefField}
                            name={telefono.name}
                            label={telefono.label}
                            value={values.telefono}
                            onChange={(e) => {
                                /** @namespace e.length **/
                                if (e && e.length > 12) {
                                    setFieldValue(telefono.name, e)
                                }
                            }}
                            withAsterisk
                        />
                    </div>
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={dni.name}
                        label={dni.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={email.name}
                        label={email.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineAutoCompleteField
                        name={codigosLocalidad.name}
                        label={codigosLocalidad.label}
                        data={localidadesData}
                        searchable
                        withAsterisk
                    />
                </Grid.Col>
            </Grid>
        </React.Fragment>
    );
}
